import { InjectionToken, Signal } from '@angular/core';

export interface CarePlanClientContext {
  /** Guid that owns the resolved metadata payload and numeric clientId. */
  activeGuid: Signal<string | null>;
  clientId: Signal<number | null>;
  error: Signal<unknown | null>;
  refresh(): void;
}

/** Supplied by the app composition root from BrightNav member metadata. */
export const CARE_PLAN_CLIENT_CONTEXT =
  new InjectionToken<CarePlanClientContext>('CARE_PLAN_CLIENT_CONTEXT');
